/* eslint-disable no-irregular-whitespace */
import { React } from "react";
import { DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export default function Policy() {
    return (
        <div>
            <DialogTitle id="alert-dialog-slide-title">
                Privacy Policy
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Date of Last Revision: September 2024
                    <br />
                    <br />
                    Greetings to the web site or mobile application (as the case
                    may be) (collectively, the “Platform”) of “Gift of
                    Legacy™. (including its subsidiaries, affiliates, agents,
                    and service providers, collectively, “Gift of Legacy™”,
                    “we”, “us” and/or “our”). This Platform is operated by “Gift
                    of Legacy™ and has been created to provide information about
                    our Gifting Activity and our online platform designed to
                    permit users to interact with one another on a Peer to Peer
                    basis to accept monetary Gifts and & to access our academy
                    and self-development courses (together with the Platform,
                    the “Services”) to our Services users and visitors (“you”,
                    “your”). This Privacy Policy sets forth “Gift of Legacy™’s
                    policy with respect to information, including personal data
                    (“Personal Data”) and other information that is collected
                    from participants using the Platform.
                    <br />
                    <br />
                    Information We Collect
                    <br />
                    <br />
                    When you interact with other participants through the
                    website, we may collect Personal Data and other information
                    from you, as further described below:
                    <br />
                    <br />
                    Personal Data That You Provide Through the Services: We
                    collect Personal Data from you (including, but not limited
                    to, your name & surname, email address and mobile number)
                    when you voluntarily provide such information, such as when
                    you interact with other participants, , register for
                    participation in the Gifting activity. Wherever “Gift of
                    Legacy™ collects Personal Data we make an effort to provide
                    a link to this Privacy Policy.
                    <br />
                    <br />
                    We collect this Personal Data purely for the purposes of
                    providing the participant/s a means to interact with other
                    participants within the guidelines of this Gifting activity,
                    as well as providing participant/s access to free academy
                    and related courses, For more details on why we collect your
                    Personal Data and how we use it, please see the section
                    below entitled “Our use of Personal Data and other
                    information.” While you are under no obligation to provide
                    any Personal Data, should you choose to withhold such
                    information, we may not be able to provide you with access
                    to become an active participant in this Gifting activity.
                    <br />
                    <br />
                    By voluntarily providing us with Personal Data, you are
                    consenting to our use of it in accordance with this Privacy
                    Policy. If you provide Personal Data to the Services, you
                    acknowledge and agree that such Personal Data may be
                    transferred from your current location to the servers
                    of Gift of Legacy™ and the authorized third parties referred
                    to herein located globally.
                    <br />
                    <br />
                    Other Information
                    <br />
                    <br />
                    Non-Personal Data: When you interact with Gift of Legacy™
                    participants through the gifting website, we automatically
                    receive and store certain non-identifiable personal
                    information. Such information, which is collected passively
                    using various technologies, cannot presently be used to
                    specifically identify you. Examples of this non-identifiable
                    personal information include the type of internet browser or
                    mobile device you use, any website from which you have come
                    to the Services, your operating system, location data (which
                    is anonymous and where you log in through the Platform you
                    will be asked if you consent to the Services accessing your
                    location, which can be updated at any time in your device
                    settings) (“Non-Personal Data”). Gift of Legacy website™ may
                    store such Non-Personal Data itself or such information may
                    be included in databases owned and maintained by Gift of
                    Legact™ service providers,affiliates or,agents. The Services
                    may use such Non-Personal Data to assist us in providing
                    effective Services and to collect broad demographic
                    information for aggregate use.
                    <br />
                    <br />
                    Aggregated Data: In an ongoing effort to better understand
                    and serve the participants of the of the Gifting platform
                    Gift of Legacy™ often conducts research on its customer
                    demographics, interests and behavior based on the Personal
                    Data, Non-Personal Data, and other information provided to
                    us. This research may be compiled and analyzed on a
                    de-identified, aggregate basis, and Gift of Legacy™ may
                    share this aggregate data with its affiliates, agents, and
                    business partners. This aggregate information does not
                    identify you personally. Gift of Legacy™ may also disclose
                    aggregated user statistics in order to describe our gifting
                    activity to current and prospective parties of interest, and
                    to other third parties for other lawful purposes & for the
                    expansion of our Gifting activity to enhance the efficacy of
                    the activity.
                    <br />
                    <br />
                    Location Information: When you use the gifting activity
                    website to to interact, collect or arrange Gifting, the
                    Services may request that you provide your city or town and
                    state or province of residence. Please keep in mind that
                    other users of the Services may be able to view your city or
                    town and state or province of residence in connection with
                    the gifting activity if it is made available within Gift of
                    Legacys™’ Public Search Directory. We may also use your
                    location information in an aggregate way, as described above
                    in the “Aggregated Data” section.
                    <br />
                    <br />
                    Social Networking Integrations: One of the rules of the
                    gifting activity of Gift of Legacys™ is that no information
                    either private or other will be displayed, shared or
                    divulged to any Social media platform.
                    <br />
                    <br />
                    You do not have the option of posting your participation
                    activity to Social Networking Services when you access
                    content through the Services (for example, you may NOT post
                    on any social media that you performed an activity on the
                    Platform); you acknowledge that if you choose to do so, you
                    risk losing your profile & further participation within the
                    Gift of Legacy™ gifting activity platform.
                    <br />
                    <br />
                    Mobile Services: The Services include certain services that
                    are available via a mobile device, including (i) the ability
                    to upload content to the Services via a mobile device, (ii)
                    the ability to browse the Platform and Services from a
                    mobile device, and (iii) the ability to access certain
                    features through an application downloaded and installed on
                    a mobile device (collectively, the “Mobile Services”). To
                    the extent you access the Services through a mobile device,
                    your wireless service carrier’s standard charges, data
                    rates, and other fees may apply. In addition, downloading,
                    installing, or using certain Mobile Services may be
                    prohibited or restricted by your carrier, and not all Mobile
                    Services may work with all carriers or devices. By using the
                    Mobile Services, you agree that other participants may
                    communicate with you regarding Gift of Legacy™by SMS, MMS,
                    text message, or other electronic means to your mobile
                    device and that certain information about your usage of the
                    Mobile Services may be communicated to us. In the event you
                    change or deactivate your mobile telephone number, you agree
                    to promptly update your Gift of Legacy™ profile account
                    information to ensure that your messages are not sent to the
                    person that acquires your old number. Similarly in cases
                    where you close e mail addresses that were used for
                    registration of participation.
                    <br />
                    <br />
                    Third-Party Personal Data: The Services may also collect
                    Personal Data relating to third parties stored in your email
                    and mobile device address books, including, without
                    limitation, names, email addresses, and phone numbers
                    (collectively, “Third-Party Personal Data”). The Services
                    may request your permission to access such Third-Party
                    Personal Data.
                    <br />
                    <br />
                    Our Use of Personal Data and Other Information
                    <br />
                    <br />
                    Gift of Legacy™ uses the Personal Data you provide in a
                    manner that is consistent with this Privacy Policy. If you
                    provide Personal Data for a certain reason, we may use the
                    Personal Data in connection with the reason for which it was
                    provided. For instance, if you contact us by email, we will
                    use the Personal Data you provide to answer your question or
                    resolve your problem. Also, if you provide Personal Data
                    about yourself, or have provided (or otherwise permitted the
                    Services to access) any Third-Party Personal Data in order
                    to obtain access to or make use of particular features of
                    the Services, we will use your Personal Data and any such
                    Third-Party Personal Data to provide you with access to such
                    services and to monitor your use of such services.
                    <br />
                    <br />
                    Gift of Legacy™ may also use your Personal Data and other
                    Non-Personal Data collected through the website based
                    gifting activity to help us in providing the hosting,
                    processing interaction information, fulfilling requests for
                    information between the Gifter and the Legend on a specific
                    board l, receiving and sending communications, updating
                    share lists, analyzing data, providing support services, or
                    other tasks from time to time.
                    <br />
                    <br />
                    Gift of Legacy™ may, with your consent, use your Personal
                    Data to contact you in the future to tell you about services
                    we believe will be of interest to you where permitted by
                    applicable law. If we do so, each marketing communication we
                    send you will contain instructions permitting you to
                    “opt-out” of receiving future marketing communications. In
                    addition, if at any time you wish not to receive any future
                    marketing communications or you wish to have your name
                    deleted from our mailing lists, please contact us as
                    indicated below.
                    <br />
                    <br />
                    We may also use your Personal Data and Third-Party Personal
                    Data to send communications relating to the Services, in
                    accordance with applicable laws. For example, we may send
                    periodic emails to registered participants of the gifting
                    activity relating to their recent interactions with another
                    participant. Also, if you use any feature of the Services
                    permitting you to communicate with third parties (such as to
                    refer a third party to the Services or to communicate with
                    them regarding this gifting activity opportunity), either by
                    submitting Third-Party Personal Data to the Services or
                    otherwise permitting the Services to automatically access
                    Third-Party Personal Data in your possession, you
                    acknowledge and agree that you have the authority of the
                    relevant third party for us to access and use the relevant
                    Third-Party Personal Data and that you have notified these
                    third parties and informed them how their information is
                    collected and used by Gift of Legacy™ to provide access to
                    participation to the gifting activity. We reserve the right
                    to identify you as the person who has made the referral in
                    any messages that are sent to them. We may use Third-Party
                    Personal Data to (1) contact such third party using the
                    Third-Party Personal Data provided, and/or (2) provide you
                    with an editable template message designed to facilitate
                    communication between you and such third party through the
                    Services. In addition to sending the foregoing
                    communications, we may also send reminders or related
                    messages to you and to third parties on your behalf from
                    time to time where permitted by applicable law. In each
                    case, any such communications sent to third parties using
                    Third-Party Personal Data will provide a means to “opt-out”
                    of receiving further communication of the same nature.
                    <br />
                    <br />
                    If Gift of Legacy™ intends on using any Personal Data in any
                    manner or for any purpose that is not consistent with this
                    Privacy Policy, we will obtain your prior informed consent
                    as required by applicable law.
                    <br />
                    <br />
                    Our Disclosure of Personal Data and Other Information
                    <br />
                    <br />
                    Gift of Legacy™ is not in the business of selling your
                    information. We consider this information to be a vital part
                    of our relationship with you. There are, however, certain
                    circumstances in which we may share your Personal Data with
                    certain third parties without further notice to you, as set
                    forth below:
                    <br />
                    <br />
                    Platform improvements & Enhancements: As we enhance/improve
                    the Gifting platform of Gift of Legacy, we might have to
                    provide the service provider data containing personal
                    information for import to the enhanced/improved platform
                    <br />
                    <br />
                    Agents, Consultants, and Related Third Parties: Gift of
                    Legacy™, may sometimes hire other service providers to
                    perform technical functions. Examples of such functions
                    include mailing information and maintaining databases. When
                    we employ another entity to perform a function of this
                    nature, we only provide them with the information that they
                    need to perform their specific function and require them to
                    only use the information for the purposes for which it was
                    collected.
                    <br />
                    <br />
                    Legal Requirements: Gift of Legacy™ may disclose your
                    Personal Data if required to do so by law or in the
                    good-faith belief that such action is necessary to (i)
                    comply with a legal obligation, (ii) protect and defend the
                    rights or property of Gift of Legacy™ creator/s, developers,
                    leaders and presenters(iii) act in urgent circumstances to
                    protect the personal safety of users of the Services or the
                    public, or (iv) protect against legal liability.
                    <br />
                    <br />
                    Cookies
                    <br />
                    <br />
                    When you interact with/through the gifting activity website,
                    we try to make that experience simple and meaningful. When
                    you visit the Platform, the web server sends a cookie to
                    your computer or mobile device (as the case may be). Cookies
                    are small pieces of information which are issued to your
                    computer or mobile device (as the case may be) when you
                    visit a website or access or use a mobile application, and
                    which store and sometimes track information about your use
                    of the Platform (as the case may be). A number of cookies we
                    use last only for the duration of your web or application
                    session and expire when you close your browser or exit the
                    application. Other cookies are used to remember you when you
                    return to the Platform. Some of the cookies used by the
                    Platform are set by us, and some are set by third parties
                    who are delivering services on our behalf. Most web and
                    mobile device browsers automatically accept cookies but, if
                    you prefer, you can change your browser to prevent that or
                    to notify you each time a cookie is set. You can also learn
                    more about cookies by
                    visiting www.allaboutcookies.org, which includes additional
                    useful information on cookies and how to block cookies using
                    different types of browsers or mobile devices. Please note,
                    however, that by blocking or deleting cookies used on the
                    Platform, you may not be able to take full advantage of the
                    Services.
                    <br />
                    <br />
                    The Platform uses cookies, and similar technologies to
                    cookies, to collect information about your access and use of
                    the Platform. You can also update your privacy settings on
                    your device by setting the “Limit Ad Tracking” and
                    Diagnostics and Usage setting property located in the
                    settings screen of your Apple iPhone or iPad, or by
                    resetting your Android ID through apps that are available in
                    the Play Store. You can also stop information collection by
                    uninstalling the App on your device and you can use the
                    standard uninstall process available as part of your device
                    for this purpose.
                    <br />
                    <br />
                    Some information on the types of cookies we use and how we
                    use them is set out below:
                    <br />
                    <br />
                    • Essential: Allow you to navigate and use all the features
                    provided by our Platform.
                    <br />
                    <br />
                    • Functional Cookies: These cookies customize elements of
                    the promotional layout and/or content of the pages of the
                    Platform and remember that you have visited us before; this
                    means we can identify the number of unique visitors we
                    receive. This allows us to make sure we have enough capacity
                    for the number of users that we get. So when you use our
                    Platform, we remember you and your preferences and
                    information you have submitted to us to provide you with a
                    customized experience.
                    <br />
                    <br />• Performance and Analytics: Performance cookies let
                    us collect information about how you use the Platform. They
                    collect anonymous statistical information about how you use
                    the Platform (including how long you spend on the Platform)
                    and where you have come to the Platform from so that we can
                    improve the Platform and learn which functions of the
                    Platform are most popular with users. This information does
                    not include Personal Data, although we might be able to
                    associate such information with user accounts once we
                    receive it from the third party.
                    <br />
                    <br />• Advertising and Targeting: These cookies collect
                    information about the pages you visit online. They gather
                    information about the pages that you visit or the functions
                    of the Platform you use, and also other information about
                    other websites that you visit, so as to place you in a
                    “market segment”. This information is only collected by
                    reference to the IP address or unique device identifier that
                    you are using (the applicable cookie identifier) and also
                    can include information about the county or province and
                    city or town you are in, together with the name of your
                    internet service provider. This information is then used to
                    place interest-based advertisements on the Platform, which
                    it is believed will be relevant to your market segment. This
                    may result in you seeing advertisements for our Platform
                    when you visit other websites.
                    <br />
                    <br />
                    We use third parties, for example, Google Analytics, to
                    analyze statistical information from users of the Platform
                    and provide you with interest-based advertisements. You can
                    understand Google Analytics further
                    at https://www.google.com/intl/en/analytics/learn/privacy.html 
                    and learn about how to manage Google Analytics settings
                    at https://tools.google.com/dlpage/gaoptout. 
                    <br />
                    <br />
                    Your Choices
                    <br />
                    <br />
                    As mentioned throughout this Privacy Policy, you can visit
                    the Platform without providing any Personal Data. If you
                    choose not to provide any Personal Data, you may not be able
                    to use certain Services.
                    <br />
                    <br />
                    Exclusion
                    <br />
                    <br />
                    This Privacy Policy does not apply to any Personal Data
                    collected by Gift of Legacy™ other than Personal Data
                    collected through the Gifting website. This Privacy Policy
                    shall not apply to any unsolicited information you provide
                    to Gift of Legacy™ through the Services or through any other
                    means. This includes, but is not limited to, information
                    posted to any public areas of the Services, such as forums
                    or comment sections, any customer support communications,
                    any ideas for new gifting rules or modifications to existing
                    gifting activity, and other unsolicited submissions
                    (collectively, “Unsolicited Information”). You agree that
                    any Unsolicited Information becomes the intellectual
                    property of Gift of Legacy™ to the furthest extent permitted
                    by applicable law, and agree to assign any and all residual
                    rights or interests that you may have in such Unsolicited
                    Information to Gift of Legacy™ All Unsolicited Information
                    shall be deemed to be non-confidential and Gift of
                    Legacy™ shall be free to reproduce, use, disclose, and
                    distribute such Unsolicited Information to others without
                    limitation or attribution to the extent permitted by
                    applicable law.
                    <br />
                    <br />
                    Children
                    <br />
                    <br />
                    Gift of Legacy™ does not knowingly collect Personal Data
                    from children under the age of 18. If you are under the age
                    of 18, please do not use the Services and/or submit any
                    Personal Data through the Services. We encourage parents and
                    legal guardians to monitor their children’s Internet usage
                    and to help enforce our Privacy Policy by instructing their
                    children never to provide Personal Data on the Services
                    without their permission. If you have reason to believe that
                    a child under the age of 18 has provided Personal Data
                    to Gift of Legacy™ through the gifting activity platform,
                    please contact us support@giftoflegacy.com, and we will
                    endeavor to delete that information from our databases.
                    <br />
                    <br />
                    Links to Other Web Sites
                    <br />
                    <br />
                    This Privacy Policy applies only to the Services. The
                    Services may contain links to other websites not operated or
                    controlled by Gift of Legacy™ (the “Third-Party Sites”). The
                    policies and procedures we described here do not apply to
                    the Third-Party Sites. The links from the Services do not
                    imply that Gift of Legacy™ endorses or has reviewed the
                    Third-Party Sites. We suggest contacting those sites
                    directly for information on their respective privacy
                    policies.
                    <br />
                    <br />
                    Security
                    <br />
                    <br />
                    Gift of Legacy™ takes reasonable steps to protect the
                    Personal Data provided via the Services from loss, misuse,
                    and unauthorized access, disclosure, alteration, or
                    destruction. However, no Internet or email transmission is
                    ever fully secure or error-free. In particular, email sent
                    to or from the Services may not be secure. Therefore, you
                    should take special care in deciding what information you
                    send to us via email. Please keep this in mind when
                    disclosing any Personal Data to Gift of Legacy™ via the
                    Internet.
                    <br />
                    <br />
                    Other Terms and Conditions
                    <br />
                    <br />
                    Your access to and use of the Gifting activity website is
                    subject to the Terms of Service at Terms and such other
                    terms, which may be made available to you in connection with
                    your use of the gifting activity. and such other terms,
                    which may be made available to you in connection with your
                    use of the gifting activity. Changes to Gift of Legacy™’s
                    Privacy Policy The gifting activity opportunity guidelines
                    and terms may change from time to time. As a result, at
                    times it may be necessary for Gift of Legacy™ to make
                    changes to this Privacy Policy. Gift of Legacy™ reserves the
                    right to update or modify this Privacy Policy at any time
                    and from time to time. Any material changes will be preceded
                    by a notice posted on the relevant Gifting activity website
                    of each participant including all community group platforms
                    If you disagree with our revisions to the Privacy Policy,
                    you may de-activate your account or discontinue the your
                    participation in the gifting activity. Please review this
                    policy periodically, and especially before you provide any
                    Personal Data. This Privacy Policy was last updated on the
                    date indicated above. Your continued use of the Services
                    after any changes or revisions to this Privacy Policy shall
                    indicate your agreement with the terms of such revised
                    Privacy Policy.
                    <br />
                    <br />
                    Access to Information; Gift of Legacy™
                    <br />
                    <br />
                    To keep your Personal Data accurate, current, and complete,
                    please review your profile and amend/edit and complete with
                    the relevant information. You may request in writing copies
                    of your Personal Data held by the gifting activity website
                    administrators. If your Personal Data that is held is
                    inaccurate, please let us know and we will make the
                    necessary amendments, erase, or block the relevant Personal
                    Data as you request and notify you within thirty (30) days
                    of such request that the relevant action has been taken.
                    Please also feel free to contact us if you have any
                    questions about Gift of Legacy™ Privacy Policy or the
                    information practices of this website based Gifting
                    activity.
                    <br />
                    <br />
                    You may contact us as follows: support@giftoflegacy.com.
                    <br />
                    <br />
                    © 2024 Gift of Legacy™
                    <br />
                    <br />
                    TERMS OF PARTICIPATION
                    <br />
                    <br />
                    I acknowledge my understanding and agree that… My Gift of
                    Legacy (GL) profile is an asset. I can participate in the
                    Gift of Legacy gifting activity or turn it over to others as
                    long as my conduct matches the Terms & Conditions as listed
                    below
                    <br />
                    <br />1 - Gift of Legacy is a gifting activity and is not an
                    investment nor a business activity. The speed of progress
                    from one board to another is not guaranteed nor predicted,
                    but is related to the pace of participation by the other
                    participants on the boards.
                    <br />
                    <br />2 - The spirit and conduct of Participants in Gift of
                    Legacy is to come together as a community creating abundance
                    for all, uplifting all participants in good standing, to
                    make and receive unconditional gifts by gifting generously,
                    and receiving graciously
                    <br />
                    <br />3 - Gift of Legacy is not responsible for any aspect
                    of the financial gifting transaction between myself and any
                    other Participants. The financial form of each gift is to be
                    agreed to between myself and Legend (receiver) when I am the
                    Gifter, and with Gifters when I am the Legend. In addition
                    to the gift amount, the sender of the gift is always
                    responsible for the sending transaction costs on their side.
                    The Legend (receiver) is always responsible for receiving
                    transaction costs on their side.
                    <br />
                    <br />4 - My participation in GL will begin with a position
                    as a Gifter on a $25 or $100 board position and requires me
                    to make an unconditional gift to the Legend on that board
                    and register 2 invitees in the platform by the time I become
                    Legend on the $100 board.
                    <br />
                    <br />5 - Taking into account the fact that Participants are
                    distributed in time zones around the world, I will initiate
                    communication between the myself and the Legend (receiver of
                    the gift) within 48 hours of placement on a board.
                    <br />
                    <br />6 - Upon progressing to the Legend position on any
                    board, I will confirm each received gift in the GL platform
                    as soon as received on my end or acceptable proof of
                    transaction is provided.
                    <br />
                    <br />7 - The communication time frame and gifting
                    transactions terms and conditions are identical on each
                    level in which I participate.
                    <br />
                    <br />8 - Acknowledging that life and external events may
                    prevent immediate communication, Gifters may be removed from
                    a board if they inform the Legend they are unable to make
                    their gift at that time or if multiple attempts have been
                    unsuccessful to communicate with them through their email,
                    phone number, community channels.
                    <br />
                    <br />9 - If the legend does not respond within 72 hours,
                    Support will intervene and replace the Legend so that
                    everyone can continue on their journey, and the Legend will
                    be required to start again. It is very important that as a
                    Legend you are totally engaged and available in the program.
                    <br />
                    <br />
                    10 - The system algorithm will prevent me from joining
                    higher boards and the perpetual cycles if my profile does
                    not have 2 confirmed at any time after completing my first
                    Bronze board. Every user can complete their first Coal and
                    Bronze board without 2 invitees. But after that their
                    journey is halted until they have 2 confirmed invitees.
                    <br />
                    <br />
                    11 – Users are encouraged to use the first 4 gifts they
                    receive to join the higher board on their first cycle. This
                    is called Fast Tracking. Users can Fast Track to all boards
                    provided they are confirmed on a board before Fast Tracking.
                    <br />
                    <br />
                    12 – Users can only join the OHANA BOARD when they are
                    confirmed on a Coal or Bronze board. Legends will only
                    receive 7 gifts ($350) as Gifter #1 is always a confirmed
                    gifter (OHANA POSITION).
                    <br />
                    <br />
                    13 – Users are encouraged to read the information under the
                    ACADEMY TAB after registering, This can be found on the top
                    right of their Gift of Legacy profile (MENU > ACADEMY)
                </DialogContentText>
            </DialogContent>
        </div>
    );
}
